/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Table_MemberInputs */



/**
* | output |
* | --- |
* | "Member" |
*
* @param {Team_Manager_Table_MemberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_table_member = /** @type {((inputs?: Team_Manager_Table_MemberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Table_MemberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Membre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitglied")
	if (locale === "it") return /** @type {LocalizedString} */ ("Membro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Участник")
	if (locale === "es") return /** @type {LocalizedString} */ ("Miembro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("成员")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メンバー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Membro")
	return /** @type {LocalizedString} */ ("Member")
});